import { render, staticRenderFns } from "./brainCardiovascularExcelUpload.vue?vue&type=template&id=04b766d5"
import script from "./brainCardiovascularExcelUpload.vue?vue&type=script&lang=js"
export * from "./brainCardiovascularExcelUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b766d5')) {
      api.createRecord('04b766d5', component.options)
    } else {
      api.reload('04b766d5', component.options)
    }
    module.hot.accept("./brainCardiovascularExcelUpload.vue?vue&type=template&id=04b766d5", function () {
      api.rerender('04b766d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/bcs/brainCardiovascularExcelUpload.vue"
export default component.exports